import { history_sensorService } from '../_services';

const state = { onRequest: false, history_sensor: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        history_sensorService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  history_sensor: state => {
    return state.history_sensor
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.history_sensor = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.history_sensor = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.history_sensor = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const history_sensors = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
